<template>
    <div 
        name="checklist-container" 
        v-show="show" 
        style="
            width: 100%;
            margin-top: 72px;
        "
    >
            <!-- Seção Projeto escondida -->
            <template v-if="false">
            <v-row class="no-margin">
                <v-col cols="12">
                    <h3>Projeto:</h3>
                </v-col>
            </v-row>
            <v-row class="no-margin">
                <v-col>
                  <v-select
                    outlined
                    label="Tipo do Projeto"
                    :items="options"
                    :rules="rulesRequired"
                    v-model="checkList.projectType"
                  >
                  </v-select>
                </v-col>
            </v-row>

            <v-divider></v-divider>
            </template>
            
            <!-- Start Project Data -->
            <template v-if="false">
            <v-row class="no-margin">
                <v-col cols="12">
                    <h3>Dados do Local:</h3>
                </v-col>
            </v-row>
            <v-row v-if="getGroupProjectType() == '2'">
                <v-col cols="4">
                    <InputNumber
                        outlined    
                        :label='"Torres / Blocos/ Galpões "'
                        @change="calculateTotalUnits()"
                        prepend-inner-icon="mdi-chess-rook"
                        :rules="rulesRequired"
                        v-model="checkList.building_type"
                    />
                    
                </v-col>
                <v-col cols="4">
                    <InputNumber
                        outlined
                        :label='"Pavimentos"'
                        required
                        @change="calculateTotalUnits()"
                        prepend-inner-icon="mdi-floor-plan"
                        :rules="rulesRequired"
                        v-model="checkList.amount_area"
                    />
                </v-col>
                <v-col cols="4">
                    <InputNumber
                        outlined
                        :label='"Unidades por pavimento"'
                        required
                        @change="calculateTotalUnits()"
                        prepend-inner-icon="mdi-home"
                        :rules="rulesRequired"
                        v-model="checkList.building_by_area"
                    />
                </v-col>
                <v-col cols="4">
                    <InputNumber
                        outlined
                        :label='"Wcs por unidade"'
                        @change="calculateTotalWc"
                        required
                        prepend-inner-icon="mdi-shower"
                        :rules="rulesRequired"
                        v-model="checkList.wcs_by_unit"
                    />
                </v-col>
                <v-col cols="4">
                    <InputNumber
                        outlined
                        label="Total de Wcs"
                        required
                        prepend-inner-icon="mdi-shower"
                        :rules="rulesRequired"
                        v-model="checkList.amount_wcs"
                    />
                </v-col>
                <v-col cols="4">
                    <InputNumber
                        outlined
                        :label='"Total de Unidades"'
                        required
                        @change="calculateTotalWc"
                        prepend-inner-icon="mdi-home"
                        :rules="rulesRequired"
                        v-model="checkList.amount_units"
                    />
                </v-col>
            </v-row>
            <v-row v-if="getGroupProjectType() == '1'">
                <v-col cols="3">
                    <v-text-field
                        outlined
                        label="Usuários"
                        type="Number"
                        prepend-inner-icon="person"
                        required
                        :rules="rulesRequired"
                        v-model="checkList.usersAmount"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        outlined
                        label="Total de Wcs"
                        type="Number"
                        prepend-inner-icon="mdi-shower"
                        required
                        :rules="rulesRequired"
                        v-model="checkList.amount_wcs"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        outlined
                        label="Chuveiro Elétrico"
                        type="Number"
                        prepend-inner-icon="mdi-shower-head"
                        required
                        :rules="rulesRequired"
                        v-model="checkList.showerEletric"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        outlined
                        label="Chuveiro a Gás"
                        type="Number"
                        prepend-inner-icon="mdi-shower-head"
                        required
                        :rules="rulesRequired"
                        v-model="checkList.showerGas"
                    >
                    </v-text-field>
                </v-col>

            </v-row>
            <!-- End Project Data -->
            </template>
            
            <!-- Start Hydrometers - Escondido -->
            <template v-if="false">
            <HydrometerList 
                :list="checkList.hydrometerList"
                :add="addHydrometer"
                :remove="removeHydrometer"
                :desiredProposal="desiredProposal"
            />
            <!-- End Hydrometers -->
            
            <v-divider></v-divider>
            </template>

            <!-- Bombas - Escondido -->
            <template v-if="false">
            <BombList 
                :show="showBombList()"
                :list="checkList.bombList"
                :add="addBomb"
                :remove="removeBomb"
            />

            <v-divider></v-divider>
            </template>
            
            <!-- Reservatórios - Escondido -->
            <template v-if="false">
            <ReservoirList 
                :show="showReservoirList()"
                :list="checkList.reservoirList"
                :add="addReservoir"
                :remove="removeReservoir"
                :desiredProposal="desiredProposal"
            />

            <v-divider></v-divider>
            </template>
            
            <!-- 
                SolutionList Component:
                projectId = create dir in firebase storage
            -->
            <SolutionList 
                :list="checkList.solutionList"
                :add="addSolution"
                :remove="removeSolution"
                :projectId="projectId"
                :proposalType="proposalType"
            />

    </div>
</template>
  
<script>
import CheckList from "./CheckList.js";
export default CheckList;
</script>
  
<style scoped>
.no-margin {
    margin: 0;
}
.d-flex {
    display: flex;
}
.f-align-center {
    align-items: center;
}
.f-1 {
    flex: 1;
}
.f-2 {
    flex: 2;
}
</style>